export default "__VITE_ASSET__c1350ed3__"